// extracted by mini-css-extract-plugin
export default {"form":"ClientesCnpjIndex_form__hBHAQ","areaBtn":"ClientesCnpjIndex_areaBtn__Bxc7X","btn":"ClientesCnpjIndex_btn__eWPND","td":"ClientesCnpjIndex_td__OF+d7"};